/* Toni Grace & Co. · site behavior for the Dwell theme (tabs, join popup, add to bag, collection filters) */
(function () {
  var d = document, de = d.documentElement;
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* tabs: occasion circles, The Desk / The Correspondence */
  d.querySelectorAll('.tg [data-tabs]').forEach(function (t) {
    t.addEventListener('click', function (e) {
      var a = e.target.closest('[data-tab]'); if (!a) return; e.preventDefault();
      t.querySelectorAll('[data-tab]').forEach(function (z) { z.classList.toggle('on', z === a); });
      var scope = t.closest('[data-scope]') || t.closest('.tg');
      scope.querySelectorAll('.tabpane').forEach(function (pn) { pn.hidden = pn.dataset.pane !== a.dataset.tab; });
    });
  });

  /* join the list popup */
  var pop = d.querySelector('.tg [data-popup]');
  function openPop() { if (!pop) return; pop.hidden = false; d.body.style.overflow = 'hidden'; var i = pop.querySelector('input[type=email]'); if (i) setTimeout(function () { i.focus(); }, 60); }
  function closePop() { if (!pop) return; pop.hidden = true; d.body.style.overflow = ''; de.style.overflow = ''; ls('tgPopup', '1'); }
  if (pop) {
    pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('[data-close]')) closePop(); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) closePop(); });
    var pf = pop.querySelector('form'); if (pf) pf.addEventListener('submit', function () { ls('tgPopup', '1'); });
    var posted = pop.querySelector('.formok, .formerr');
    if (posted) {
      var other = d.querySelector('.tg .join .formok, .tg .join .formerr');
      if (other) other.scrollIntoView({ block: 'center' }); else openPop();
    } else if (pop.hasAttribute('data-auto') && !pop.hasAttribute('data-wait') && pop.hidden && !ls('tgPopup') && !/customer_posted/.test(location.search)) {
      openPop();
    }
  }
  d.querySelectorAll('.tg [data-notify]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); if (pop) openPop(); });
  });

  /* dots under the swipe rows on a phone */
  d.querySelectorAll('.tg .um').forEach(function (um) {
    var n = um.children.length; if (n < 2) return;
    var dots = d.createElement('div'); dots.className = 'umdots'; dots.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < n; i++) {
      var b = d.createElement('button'); b.type = 'button'; b.tabIndex = -1;
      (function (k) { b.addEventListener('click', function () { var c = um.children[k]; um.scrollTo({ left: c.offsetLeft - um.offsetLeft, behavior: 'smooth' }); }); })(i);
      dots.appendChild(b);
    }
    um.after(dots);
    function upd() {
      var best = 0, bd = 1e9;
      for (var i = 0; i < n; i++) { var dd = Math.abs(um.children[i].offsetLeft - um.offsetLeft - um.scrollLeft); if (dd < bd) { bd = dd; best = i; } }
      dots.querySelectorAll('button').forEach(function (x, k) { x.classList.toggle('on', k === best); });
    }
    um.addEventListener('scroll', upd, { passive: true }); upd();
  });

  /* Graceful living reveal */
  if ('IntersectionObserver' in window) {
    de.classList.add('fx-on');
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.2 });
    d.querySelectorAll('.tg .belief--fx').forEach(function (el) { io.observe(el); });
  }

  /* add to bag from any card */
  var toastEl = d.querySelector('.tg [data-toast]'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.querySelector('[data-toast-t]').textContent = msg; toastEl.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.hidden = true; }, 4500);
  }
  var drawer = d.querySelector('cart-drawer-component');
  function bubble(cart) {
    try { d.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'tg-card', data: { itemCount: cart.item_count, source: 'tg-card' } } })); } catch (e) {}
  }
  function added(cart) { bubble(cart); if (!drawer) toast('Added to your bag.'); }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  d.addEventListener('click', function (e) {
    var b = e.target.closest('.tg [data-add]'); if (!b) return; e.preventDefault();
    if (b.disabled) return; b.disabled = true; var txt = b.textContent; b.textContent = 'Adding';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.add, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { b.textContent = 'Added'; added(cart); setTimeout(function () { b.textContent = txt; b.disabled = false; }, 1800); })
      .catch(function (err) { b.textContent = txt; b.disabled = false; toast((err && err.description) || 'That piece could not be added. Please try again.'); });
  });

  /* product page: thumbnails, variant price, quantity, add to bag */
  d.querySelectorAll('.tg[data-p="product"]').forEach(function (pg) {
    var main = pg.querySelector('[data-pmain]');
    pg.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { if (main) { main.removeAttribute('srcset'); main.src = t.dataset.thumb; } pg.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('on', x === t); }); });
    });
    var form = pg.querySelector('form.pform'); if (!form) return;
    var qty = form.querySelector('[data-qty]'), btn = form.querySelector('[data-padd]'), price = pg.querySelector('[data-pprice]'), vsel = form.querySelector('[data-vsel]');
    form.querySelectorAll('[data-q]').forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + (+b.dataset.q)); }); });
    if (vsel) vsel.addEventListener('change', function () { var o = vsel.selectedOptions[0]; if (price) price.textContent = o.dataset.price; var av = o.dataset.av === 'true'; btn.disabled = !av; btn.textContent = av ? 'Add to bag' : 'Sold out'; });
    form.addEventListener('submit', function (e) {
      e.preventDefault(); if (btn.disabled) return; btn.disabled = true; var txt = btn.textContent; btn.textContent = 'Adding';
      var id = +(form.querySelector('[name="id"]').value), q = Math.max(1, parseInt(qty.value, 10) || 1);
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: q }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) { btn.textContent = 'Added'; added(cart); setTimeout(function () { btn.textContent = txt; btn.disabled = false; }, 1800); })
        .catch(function (err) { btn.textContent = txt; btn.disabled = false; toast((err && err.description) || 'That piece could not be added. Please try again.'); });
    });
  });

  /* collection: room chips, room and price checkboxes, sort */
  d.querySelectorAll('.tg [data-shop]').forEach(function (shop) {
    var tg = shop.closest('.tg'), chips = tg.querySelector('[data-chips]'), grid = shop.querySelector('[data-grid]'),
        cnt = tg.querySelector('[data-count]'), none = shop.querySelector('[data-none]'), rooms = [], prs = [];
    function apply() {
      var n = 0;
      grid.querySelectorAll('.pc').forEach(function (c) {
        var r = c.dataset.rooms || '', p = +c.dataset.price || 0;
        var okR = !rooms.length || rooms.some(function (x) { return r.indexOf('|' + x + '|') >= 0; });
        var okP = !prs.length || prs.some(function (x) { var a = x.split('-'); return p >= +a[0] && p < +a[1]; });
        c.hidden = !(okR && okP); if (okR && okP) n++;
      });
      if (cnt) cnt.textContent = n;
      if (none) none.hidden = n > 0;
      if (chips) chips.querySelectorAll('[data-room]').forEach(function (a) { var v = a.dataset.room; a.classList.toggle('on', v ? (rooms.length === 1 && rooms[0] === v) : !rooms.length); });
      shop.querySelectorAll('input[data-room]').forEach(function (i) { i.checked = rooms.indexOf(i.dataset.room) >= 0; });
    }
    if (chips) chips.addEventListener('click', function (e) { var a = e.target.closest('[data-room]'); if (!a) return; e.preventDefault(); rooms = a.dataset.room ? [a.dataset.room] : []; apply(); });
    shop.addEventListener('change', function (e) {
      var i = e.target;
      if (i.hasAttribute('data-room')) rooms = [].map.call(shop.querySelectorAll('input[data-room]:checked'), function (x) { return x.dataset.room; });
      if (i.hasAttribute('data-pr')) prs = [].map.call(shop.querySelectorAll('input[data-pr]:checked'), function (x) { return x.dataset.pr; });
      apply();
    });
    var ft = tg.querySelector('[data-ftoggle]'); if (ft) ft.addEventListener('click', function () { shop.classList.toggle('fopen'); });
  });
  /* room pages: keep the current room button in view on a phone */
  d.querySelectorAll('.tg [data-chips]').forEach(function (c) {
    var on = c.querySelector('a.on'); if (!on || c.scrollWidth <= c.clientWidth) return;
    c.scrollLeft = c.scrollLeft + on.getBoundingClientRect().left - c.getBoundingClientRect().left - 16;
  });
  d.querySelectorAll('.tg [data-sort]').forEach(function (s) {
    s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); });
  });
})();
